import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import EventMetrics from "./EventMetrics";

createRoot(document.getElementById("tmt-event-metrics")).render(
  <StrictMode>
    <EventMetrics />
  </StrictMode>
);
